import { Color, RGBColor } from "../../defines/colors"
import { ItemType } from "../../defines/enums"
import { Symbol } from "../../defines/symbols"
import { Position, RenderText } from "../../defines/types"
import { Item } from "./item"

export class Hint extends Item {
  constructor(public contents: string, type: ItemType, position: Position) {
    const name = type == ItemType.HINT_COLLECTIBLE ? "collectible hint" : "hint"
    const render = {
      symbol: [Symbol.HINT],
      light: Color.HINT_LIGHT,
      dark: Color.HINT_DARK,
    }
    const levelRequired = 1
    super(type, levelRequired, position, render, name)
  }

  renderText(): RenderText {
    let color = RGBColor.MESSAGE_INFO
    let tag: string = "INFO"

    if (this.type == ItemType.HINT_COLLECTIBLE) {
      color = RGBColor.MESSAGE_GOOD
      tag = "COLL"
    } else if (this.type == ItemType.HINT_WARNING) {
      color = RGBColor.MESSAGE_WARNING
      tag = "WARN"
    }

    return { text: "[" + tag + "] " + this.contents, color: color }
  }
}
